module.exports = __webpack_public_path__ + "img/icon-user-outline.25e8bbf1.svg";